import { render, staticRenderFns } from "./ChannelInfoModal.vue?vue&type=template&id=27973889&"
import script from "./ChannelInfoModal.vue?vue&type=script&lang=js&"
export * from "./ChannelInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27973889')) {
      api.createRecord('27973889', component.options)
    } else {
      api.reload('27973889', component.options)
    }
    module.hot.accept("./ChannelInfoModal.vue?vue&type=template&id=27973889&", function () {
      api.rerender('27973889', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/onboardingShell/steps/channel/ChannelInfoModal.vue"
export default component.exports